module.exports = "//img1.rrcimg.com/_next/static/src/assets/hb_Va7Ls.png";